import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiClient, BranchInfo } from '../sdk/sdk';

@Injectable({
  providedIn: 'root',
})
export class BranchService {
  private readonly sdk: ApiClient = inject(ApiClient);
  private readonly multiSelection$ = new BehaviorSubject<BranchInfo[]>([]);

  getBranches(): Observable<BranchInfo[]> {
    return this.sdk.listBranches();
  }

  getSelectedBranches(): Observable<BranchInfo[]> {
    return this.multiSelection$.asObservable();
  }

  setSelectedBranches(branches: BranchInfo[]): void {
    this.multiSelection$.next(branches);
  }

  clearSelectedBranches(): void {
    this.multiSelection$.next([]);
  }
}
